import { Controller } from "@hotwired/stimulus"

// LRPO-5861 — closes a custom-modal when its BACKDROP is clicked.
//
// Replaces an inline `onclick="closeModalOnBlackDropClick(event)"` plus a
// per-view <script> that assigned a global of that name. Around fifty modals
// in this app each assign the SAME global, so only the most recently rendered
// one owns it. Open a second modal and the first can no longer close itself:
// the global now points at the other modal's closer, which hides an id that is
// not on screen and clears a frame that is not the one showing. No error, no
// console output — it simply stops responding. That is exactly the sequence in
// the report: open a counter, close it, open ANOTHER counter, and the backdrop
// is dead.
//
// A controller instance is bound to its own element and reads its own values,
// so two of them on one page cannot collide.
//
// The territory copy carried a second defect: it was declared `function ()`
// with no parameter while being called as `closeModalOnBlackDropClick(event)`,
// so it could not see what had been clicked and fired for clicks INSIDE the
// dialog too — every button in the modal dismissed it. Here the handler
// receives the event and acts only on the backdrop itself.
export default class extends Controller {
  static values = { frame: String }

  close(event) {
    // Only the backdrop. Clicks on the dialog bubble up to this element and
    // must be ignored, or the modal closes under the user mid-edit.
    if (event.target !== this.element) return

    this.element.style.display = "none"
    this._clearFrame()
  }

  // Turbo will not re-fetch a frame that still carries its src, so reopening
  // the same counter would silently do nothing. This empties our own
  // container — replaceChildren rather than innerHTML, so no markup is parsed.
  _clearFrame() {
    if (!this.hasFrameValue || this.frameValue === "") return

    const frame = document.getElementById(this.frameValue)
    if (!frame) return

    frame.removeAttribute("src")
    frame.removeAttribute("busy")
    frame.removeAttribute("reloadable")
    frame.replaceChildren()
  }
}
